export const nonProjects = ['Szabadság', 'Szünet', 'Táppénz', 'Fizetett Távollét', 'Igazolt Távollét']
export const travellingTasks = ['Jármű Utas', 'Jármű Vezető']

export const ROLES = {
    ROLE_EMPLOYEE: "Dolgozó",
    ROLE_CEO: "Cégvezető",
    ROLE_ADMIN: "Adminisztrátor",
    ROLE_GUEST: "Vendég"
};

export const PRIORITIES = {
    EXTRA_IMPORTANT: "Extra fontos",
    IMPORTANT: "Fontos",
    NORMAL: "Normál",
    NOT_IMPORTANT: "Nem fontos"
};

export const STATUSES = {
    NOT_STARTED: "Nincs elkezdve",
    IN_PROGRESS: "Folyamatban",
    DONE: "Befejezve"
};

export const SALARY_TEMPLATES = {
    NORMAL: "Normál",
    ONLY_HOUR_BASED: "Csak Óra Alapú",
    EXTERNAL_SUBCONTRACTOR: "Külsős"
}

export const INVOICE_TYPES = {
    INVOICE: "Számla",
    ADVANCE_INVOICE: "Előlegszámla",
    FEE_REQUEST: "Díjbekérő",
    RECEIPT: "Nyugta"
}